import { render } from "./techArtMuseum.vue?vue&type=template&id=e0c07558&scoped=true"
import script from "./techArtMuseum.vue?vue&type=script&lang=js"
export * from "./techArtMuseum.vue?vue&type=script&lang=js"

import "./techArtMuseum.vue?vue&type=style&index=0&id=e0c07558&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c07558"]])

export default __exports__